import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import IZendeskForm from '../../core/entities/iZendeskForm';
import { IZendeskSubmitFormUseCase } from '../../core/usecases/zendesk/SubmitFormUseCase';

export interface IZendeskService {
    submitForm(payload: IZendeskForm, credentials: string): Promise<any>;
}

export class ZendeskService implements IZendeskService {
    // Lazy getter for dependency to avoid circular dependencies
    private get submitFormUseCase(): IZendeskSubmitFormUseCase {
        return container.resolve<IZendeskSubmitFormUseCase>(DI.USECASES.IZendeskSubmitFormUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async submitForm(payload: IZendeskForm, credentials: string): Promise<any> {
        return await this.submitFormUseCase.execute(payload, credentials);
    }
}
